export default __webpack_public_path__ + "dbf1871bde2e2618e823f46b387cc8d3.svg";